import React from "react";

interface Props {
  className?: string;
}

export default function BullHorn(props?: Props) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        d="M12.9085 30.75C12.6325 32.959 10.6175 33.75 8.40848 33.75C6.19948 33.75 4.63248 31.959 4.90848 29.75L5.90848 20.75C6.18448 18.541 8.19948 16.75 10.4085 16.75C12.6175 16.75 16.8765 16.75 13.9085 20.75C10.9405 24.75 12.9085 30.75 12.9085 30.75Z"
        fill="#BE1931"
      />
      <path
        d="M35.8258 14.75C35.8258 21.652 34.2818 27.25 32.3758 27.25C30.4708 27.25 11.9258 21.652 11.9258 14.75C11.9258 7.847 30.4708 2.25 32.3758 2.25C34.2818 2.25 35.8258 7.847 35.8258 14.75Z"
        fill="#CCD6DD"
      />
      <path
        d="M32.3758 27.25C34.2812 27.25 35.8258 21.6536 35.8258 14.75C35.8258 7.84644 34.2812 2.25 32.3758 2.25C30.4704 2.25 28.9258 7.84644 28.9258 14.75C28.9258 21.6536 30.4704 27.25 32.3758 27.25Z"
        fill="#66757F"
      />
      <path
        d="M17.9258 21.75L3.92578 20.75C-1.07422 20.75 -1.07422 8.75 3.92578 8.75L17.9258 7.75C14.9258 10.75 14.9258 18.75 17.9258 21.75Z"
        fill="#DD2E44"
      />
      <path
        d="M31.3242 19.0983C32.1526 19.0983 32.8242 17.1517 32.8242 14.7503C32.8242 12.349 32.1526 10.4023 31.3242 10.4023C30.4958 10.4023 29.8242 12.349 29.8242 14.7503C29.8242 17.1517 30.4958 19.0983 31.3242 19.0983Z"
        fill="#99AAB5"
      />
    </svg>
  );
}
